export default __webpack_public_path__ + "static/media/025-independence.a9d0b188.svg";